import { useMemo, useState, useEffect } from 'react'
import { useAtom } from 'jotai'

import { Stack, StackDivider } from '@chakra-ui/react'

import { buildUrlString } from '@!/Util/buildUrlString'
import { ListItem } from '@!/Store/FeatureList/components'
import { userHashAtom } from '@!/atoms/userInfoAtom'
import { useCheckPurchasedBooks } from '@!/Hooks'
import { CircularProgressModal } from '@!/components/Modal'

export const ContentListItem = ({ content, isPurchased }) => {
  const linkUrl = buildUrlString(`/store/books/${content.content_id}`)
  return (
    <ListItem
      title={content.content_name}
      imageUrl={content.image_url}
      authorName={content.author_name}
      publisherName={content.publisher_name}
      price={content.price}
      regularPrice={content.regular_price}
      sampleBookId={content.sample_content_id}
      contentId={content.content_id}
      adultFlag={content.adult_flag}
      sampleFilePath={content.sample_file_path}
      linkUrl={linkUrl}
      isPurchased={isPurchased}
    />
  )
}

export const ContentList = ({ contents }) => {
  const [userHash] = useAtom(userHashAtom)
  const contentIds = useMemo(() => contents.map((content) => content.content_id), [contents])
  const { data: purchasedBookIds, isSuccess: isSuccess, isLoading: isLoading } = useCheckPurchasedBooks(userHash, contentIds)
  const [listItems, setListItems] = useState(contents)

  useEffect(() => {
    if (!isSuccess) return

    // content_idがpurchasedBookIdsに存在するかどうかをpurchasedに保存してlistItemsを更新
    setListItems(
      contents.map((content) => {
        content.purchased = purchasedBookIds.some((purchasedBookId) => purchasedBookId == content.content_id)
        return content
      }),
    )
  }, [isSuccess])

  const canRender = useMemo(() => (!!userHash && isSuccess) || !userHash, [userHash, isSuccess])

  return (
    <Stack divider={<StackDivider />} spacing={0}>
      <CircularProgressModal isOpen={isLoading} />
      {canRender && listItems.map((content, index) => <ContentListItem key={`content-list-item-${index}`} content={content} isPurchased={content.purchased} />)}
    </Stack>
  )
}
